import axios from 'axios';
import { ProductionDataUpload, SanitationDataUpload } from 'views/shrimp-data-upload/types/shrimp-data-upload.type';

export const postUploadProductionDataFile = async (fileName: string, file: File): Promise<ProductionDataUpload> => {
  const res = await axios.post<ProductionDataUpload>(`/ewosapi/v1/shrimp-data/${fileName}`, file, {
    headers: {
      'Content-Type': file.type,
    },
  });
  return res.data;
};

export const postUploadSanitationDataFile = async (fileName: string, file: File): Promise<SanitationDataUpload> => {
  const res = await axios.post<SanitationDataUpload>(`/ewosapi/v1/shrimp-data/sanitation/${fileName}`, file, {
    headers: {
      'Content-Type': file.type,
    },
  });
  return res.data;
};
